export default "__VITE_ASSET__81ca80ac__"